function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/checkmark");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.7934282,32.0445143 C23.1543928,31.4054807 22.1183118,31.4054807 21.4792765,32.0445143 C20.8402412,32.6835478 20.8402412,33.7196259 21.4792765,34.3586595 L25.6413031,38.5206744 C26.355344,39.2347134 27.5393537,39.1379458 28.1279778,38.3174418 L38.6931223,23.590312 C39.219915,22.8559969 39.0516832,21.8336682 38.3173661,21.3068769 C37.5830489,20.7800856 36.5607173,20.9483169 36.0339245,21.682632 L26.5924125,34.8434908 L23.7934282,32.0445143 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "select/option/selected",
  transform: "translate(-336.000000, -21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/checkmark",
  transform: "translate(315.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/30x30"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u21B3-bg",
  x: 0,
  y: 0,
  width: 60,
  height: 60
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Stroke-756",
  fill: "#4B89DC",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "attribute/color/black",
  mask: "url(#mask-2)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}))))));

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.513f0434.svg";
export { ForwardRef as ReactComponent };